module.exports = __webpack_public_path__ + "static/media/arrow-left-white.e31a36be.svg";